import Styles from './index.module.scss';
import Button from "../../shared/elements/button";
import i18n from '../../../utils/translations/i18n';
import ErrorBar from '../../shared/elements/errorBar';

const EmailSentPage = ({ email, handleSubmit, errorBarState }) => {
    const { t } = i18n;
    const emailSentText = t('forgot_password.emailSent').split('[]'); 
    return (
            <form className={Styles.form}>
                {errorBarState.isActive && <div className={Styles.errorContainer}>
                        <ErrorBar message={errorBarState.message}/>
                </div>}
                <div className={Styles.header}>
                    <h2 className={Styles.titleEmailPage}>{t('reset_password.sent_title')}</h2>
                </div>
                <div className={Styles.subtitleEmailPage}>
                    {/* {`If an account exists for `} <strong>{email}</strong>{`, an email will be sent with a password reset link. Still not showing up? Request a new email below.`} */}
                    {emailSentText[0]} <strong data-hj-suppress >{email}</strong>{emailSentText[1]}
                </div>
                <Button id="resend-button" type="submit" onClick={handleSubmit} subClass="btn--pill" className={Styles.resendButton}>
                    {t('reset_password.resend_email')}
                </Button>
            </form>

    )
}

export default EmailSentPage;
